export const isWeekend = date => {
  const day = date.getDay();
  return day === 0 || day === 6;
};

export const formatLocalISO = date => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};

export const startOfMonthFrom = (d) => {
  if (!d) return null;
  const dt = d instanceof Date ? d : new Date(d);
  if (isNaN(dt)) return null;
  return new Date(dt.getFullYear(), dt.getMonth(), 1);
};

export const addWeekdays = (startDate, weekdaysToAdd) => {
  const result = new Date(startDate);
  let added = 0;
  while (added < weekdaysToAdd) {
    result.setDate(result.getDate() + 1);
    if (!isWeekend(result)) {
      added++;
    }
  }
  return result;
};

export const normaliseArrayField = (field) => {
  if (!field) return [];
  if (Array.isArray(field)) return field;
  return String(field).split(',').map(s => s.trim()).filter(Boolean);
};
